import type { AuditLogEventDto, AuditLogPageDto } from '@shared/api/contracts';
import type { AuditLogEvent, AuditLogPage } from '../model/types';

const asId = (id: string): string => id;

export const mapAuditLogEvent = (dto: AuditLogEventDto): AuditLogEvent => ({
  id: asId(dto.id),
  occurredAt: dto.occurredAt,
  eventType: dto.eventType,
  description: dto.description,
  category: dto.category,
  outcome: dto.outcome,
  actor: {
    type: dto.actor?.type ?? '',
    userId: dto.actor?.userId ?? null,
    role: dto.actor?.role ?? null,
    label: dto.actor?.label ?? null,
    apiKeyFingerprint: dto.actor?.apiKeyFingerprint ?? null,
  },
  subjectUserId: dto.subjectUserId,
  projectId: dto.projectId,
  target: dto.target,
  ip: dto.ip,
  userAgent: dto.userAgent,
  requestId: dto.requestId,
  sessionRef: dto.sessionRef,
  reason: dto.reason,
  changes: dto.changes,
  metadata: dto.metadata,
  merchantVisible: Boolean(dto.merchantVisible),
});

export const mapAuditLogPage = (dto: AuditLogPageDto): AuditLogPage => ({
  items: (dto.items ?? []).map(mapAuditLogEvent),
  nextCursor: dto.nextCursor,
  period: dto.period,
});
